var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6003 15.4002C16.6003 15.4002 16.732 9.80553 18.8008 7.73661C20.4655 6.07192 23.0377 5.94544 24.5463 7.45397C26.0547 8.96258 25.9282 11.5349 24.2636 13.1996C22.1948 15.2685 16.6003 15.4002 16.6003 15.4002ZM15.4001 15.4002C15.4001 15.4002 15.2684 9.80553 13.1996 7.73661C11.535 6.07192 8.96272 5.94544 7.45418 7.45397C5.94571 8.96258 6.07218 11.5349 7.7368 13.1996C9.80563 15.2685 15.4001 15.4002 15.4001 15.4002ZM13.1993 24.2642C15.2681 22.1953 15.3999 16.6006 15.3999 16.6006C15.3999 16.6006 9.80531 16.7323 7.73648 18.8012C6.07194 20.4658 5.94547 23.0382 7.45394 24.5468C8.96248 26.0554 11.5347 25.9288 13.1993 24.2642ZM16.6009 16.6006C16.6009 16.6006 16.7326 22.1953 18.8015 24.2642C20.466 25.9288 23.0383 26.0554 24.5468 24.5468C26.0554 23.0382 25.9288 20.4658 24.2643 18.8012C22.1954 16.7323 16.6009 16.6006 16.6009 16.6006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTframe);
export default __webpack_public_path__ + "static/media/tframe.4d63756784725b52928672941fe11b6d.svg";
export { ForwardRef as ReactComponent };